import validate from "/home/runner/work/wow-guide/wow-guide/frontend-wg3m/node_modules/nuxt/dist/pages/runtime/validate.js";
import onboarding_45global from "/home/runner/work/wow-guide/wow-guide/frontend-wg3m/middleware/onboarding.global.ts";
import manifest_45route_45rule from "/home/runner/work/wow-guide/wow-guide/frontend-wg3m/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  onboarding_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}